/* eslint-disable  */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'components/Container';

const ProtectedRenderWrapper = ({
  isInitInProgress,
  isInitialized,
  initialize,
  component,
  renderProps,
  product,
  initializedProduct
}) => {
  const Render = component;

  const getVariant = () => {
    return {
      variant: 'dark',
      bg: 'turquoise'
    };
  };

  useEffect(() => {
    if (
      (!isInitialized && !isInitInProgress) ||
      (!isInitInProgress && product !== initializedProduct)
    ) {
      initialize(false, product);
    }
  }, []);

  if (isInitialized && !isInitInProgress) {
    return <Render {...renderProps} />;
  }

  return <Container isLoading variant={getVariant().variant} bg={getVariant().bg} />;
};

ProtectedRenderWrapper.propTypes = {
  user: PropTypes.object.isRequired,
  isInitInProgress: PropTypes.bool,
  isInitialized: PropTypes.bool,
  component: PropTypes.any.isRequired,
  renderProps: PropTypes.object.isRequired,
  initialize: PropTypes.func.isRequired
};

export default ProtectedRenderWrapper;
